mainApp.directive('dynamicList', function() {
    return {
        templateUrl: '/public/directives/dynamiclist.html',
        scope: {
            model: "=",
            inner: "@",
            label: "@",
            placeholder: "@"
        },
        controller: function($scope) {
            $scope.items = null;
            $scope.remove = function(item){
                $scope.model.splice($scope.model.indexOf(item), 1);
            };
            $scope.addNew = function(data){
                if (!data || data === undefined)
                    data = null;
                var a = {};
                a[$scope.inner] = data;
                $scope.model.push(a);
            }
        }
    };
});
